import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import Helmet from 'react-helmet';
import {
  withRouter,
  GelContentRow,
  ScaleCard,
  StatCard,
  InfographicCard,
  StackedCard,
  StyleguideContext,
  FormBack,
  Sanitize
} from 'cw-styleguide-react';
import {route} from "../routes";

class JobDetailView extends Component {

  componentDidMount() {
    window.initialiseCard();
    this.context.setLanguageUrl(this.props.data.slugTrans);
  }


  render() {

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} | {this.props.t('app.name')}</title>
        </Helmet>

        <h1>{this.props.data.name}</h1>

        <GelContentRow>

          <StackedCard
            link={false}
            imageRight={false}
            colour={'brand-a'}
            source={this.props.data.landingPageImage.src}
            alt={this.props.data.landingPageImage.alt}
            readMore={{
              to: '/' + this.props.params.jobid + route('role')
            }}
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_role_title')}
            classes={['gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80', 'card--option', 'option--b']}
          >
            <Sanitize html={this.props.data.description}/>
          </StackedCard>


          <ScaleCard
            width={100}
            title={this.props.t('misc.payTitle')}
            from={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') : (this.props.data.pay.starting ? "£" + this.props.data.pay.starting.toLocaleString()  : "")}
            to={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') : (this.props.data.pay.experienced ? "£" + this.props.data.pay.experienced.toLocaleString() + (this.props.data.pay.moreFlag ? "+" : "" ) : "")}
            start={this.props.t('styleguide:pay_starting')}
            end={this.props.t('styleguide:pay_experienced')}
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_pay_title')}
            classes={['card--option', 'gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80']}
          />

          <StatCard
            link={false}
            width={100}
            colour={'brand-f'}
            title={''}
            rows={
              [
                {
                  icon: 'alarm',
                  text: <Fragment>
                    <p>{this.props.t('misc.typicalHoursTitle')}</p>
                    { this.props.data.hours.hoursIrregular && this.props.data.hours.hoursIrregular == "Yes" ?
                      <p>{this.props.t('local:misc.typicalIrregular')}</p>
                      :   <p><span>{this.props.data.hours.hours}</span> {this.props.t('local:misc.typicalHoursCounter')} </p>}
                    <p>{this.props.data.hours.shiftPatterns.join(',')}</p>
                      </Fragment>
                },

              ]
            }
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_pay_title')}
            classes={['card--option', 'option--b', 'gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80']}
          />


          {/* Is this right for me */}
          <StackedCard
            size={'large'}
            link={false}
            imageRight={false}
            colour={''}
            source={this.props.data.skillsImage}
            alt={''}
            title={<Sanitize html={this.props.data.rightForMeStatic} />}
            readMore={{
              to: '/' + this.props.params.jobid + route('right')
            }}
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_role_title')}
            classes={['card--option', 'option--b', 'gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80']}
          >
            <Sanitize html={this.props.data.rightForMeText}/>
          </StackedCard>

          {/* Things to think about */}
          <StackedCard
            size={'large'}
            link={false}
            imageRight={false}
            colour={''}
            source={this.props.data.thinkAboutImage}
            alt={''}
            title={<Sanitize html={this.props.data.thinkAboutStatic} />}
            readMore={{
              to: '/' + this.props.params.jobid + route('think')
            }}
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_role_title')}
            classes={['card--option', 'option--b', 'gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80']}
          >
            <Sanitize html={this.props.data.thinkAboutText}/>
          </StackedCard>


          {/* Qualifications*/}
          <StackedCard
            size={'large'}
            link={false}
            imageRight={false}
            title={<Sanitize html={this.props.data.qualificationStatic} />}
            colour={''}
            source={this.props.data.qualificationsImage}
            alt={''}
            readMore={{
              to: '/' + this.props.params.jobid + route('qualifications')
            }}
            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_role_title')}
            classes={['card--option', 'option--b', 'gel-lg-mb-80', 'gel-md-mb-80', 'gel-sm-mb-80']}
          >
            <Sanitize html={this.props.data.qualificationText}/>
          </StackedCard>


          {/*</InfographicCard>*/}
          <InfographicCard
            link={false}
            width={100}
            size={'large'}
            colour={'brand-f'}
            title={this.props.data.openingsData.text }
            source={this.props.data.openingsImage}
            stat={this.props.data.openingsData.value && {counter: this.props.data.openingsData.value}}

            hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('view.dataDetail.openings.title')/*(this.props.openingsText? this.props.openingsText : this.props.t('route_become_title'))*/}
            classes={['card--option']}
          >
            <p>{this.props.data.lightcastRefYear}</p>
          </InfographicCard>
        </GelContentRow>


        <FormBack url={'/'} title={this.props.data.career}/>
      </Fragment>
    )
  }
}

JobDetailView.contextType = StyleguideContext;

export default withRouter(withTranslation(['local', 'styleguide'])(JobDetailView));
